import type { Mission } from '../missions.ts'

export const usaid: Mission = {
  id: "usaid",
  name: "U.S. Agency for International Development",
  short: "USAID",
  call: "Development",
  kind: "independent",
  url: "https://www.usaid.gov/",
  established: 1961,
  palette: {
    primary: "#002a6c",
    secondary: "#004990",
    accent: "#c2113a",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Agency_for_International_Development.svg",
  },
  motif: "hands",
  mission: {
    text: "We work to build a freer, more equitable and more humane world by amplifying local voices, advancing sustainable progress, and tackling the world's toughest problems.",
    url: "https://www.performance.gov/agencies/usaid/",
  },
  fact: {
    text: "USAID was established in 1961 under Executive Order 10973 to implement components of the Foreign Assistance Act of 1961.",
    url: "https://www.congress.gov/crs_external_products/IF/PDF/IF10261/IF10261.20.pdf",
  },
  seal: {
    file: "public/seals/usaid.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Agency_for_International_Development.svg",
  },
  identifier: {
    oig: "https://oig.usaid.gov/",
    performance: "https://www.performance.gov/agencies/usaid/",
  },
  media: {
    photos: [
      {
        file: "/media/usaid-relief-warehouse.jpg",
        small: "/media/usaid-relief-warehouse-sm.jpg",
        alt: "Rows of tall warehouse racks loaded with pallets of boxed relief supplies marked with the USAID logo, seen from floor level.",
        title: "USAID emergency relief supplies stored at a logistics warehouse in Miami, Florida, August 26, 2011",
        creator: "U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:A_warehouse_full_of_USAID_goods_-_20110826-FS-LSC-0046_-_Flickr_-_USDAgov.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usaid-beirut-airlift.jpg",
        small: "/media/usaid-beirut-airlift-sm.jpg",
        alt: "View from inside a cargo aircraft as a pallet of boxed medical supplies is loaded through the open rear ramp.",
        title: "Emergency medical supplies for Beirut loaded at Ramstein Air Base, Germany, August 11, 2020",
        creator: "Staff Sgt. Kirby Turbak, U.S. Air Force",
        source: "https://commons.wikimedia.org/wiki/File:Ramstein_Airmen_transport_USAID_medical_aid_to_Beirut_(6303423).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
